//@flow
import * as React from 'react';
import Input from 'common/components/core/input';
import type { UploadFilesValueType } from 'common/components/core/dropzone/DragDrop';

export type InputValueType =
    | {
          value: string,
          modified: boolean
      }
    | UploadFilesValueType
    | string;

type InputSourceType = {
    fieldId: string,
    label?: string,
    placeholder?: string,
    type?: string,
    inputValue: InputValueType
};
type InputSourceListType = Array<InputSourceType>;

export type InputValueListType = { [fieldId: string]: InputValueType };

type Props = {
    inputs: InputSourceListType,
    theme: Object
};
class InputList extends React.PureComponent<Props, void> {
    onInputChange = (value: string | Object, fieldId: string) => {
        const { inputs } = this.props;
        const inputValues = {};
        let listChanged = false;

        inputs.forEach(input => {
            const inputFieldId = input.fieldId;
            //set modified false for all
            inputValues[inputFieldId] = {
                ...input,
                value: input.value,
                inputValue: {
                    value: input.inputValue.value,
                    modified: false
                }
            };

            //check if modified
            if (inputFieldId === fieldId) {
                if (input.inputValue.value !== value) {
                    listChanged = true;
                    inputValues[fieldId] = {
                        ...input,
                        value,
                        inputValue: {
                            value,
                            modified: true
                        }
                    }; //if changed, updated
                }
                if (input.type === 'file') {
                    if (input.inputValue.value.newFiles !== value.newFiles) {
                        listChanged = true;
                        inputValues[fieldId] = {
                            ...input,
                            value,
                            inputValue: {
                                value,
                                modified: true
                            }
                        }; //if changed, updated
                    }
                }
            }
        });
        if (listChanged) {
            this.onListChange(inputValues);
        }
    };

    onListChange = list => {
        const { onListChange } = this.props;
        onListChange && onListChange(list);
    };

    render() {
        const { inputs, theme } = this.props;
        return (
            <div className={theme.inputList}>
                {inputs.map(input => {
                    const {
                        fieldId,
                        inputValue,
                        label,
                        placeholder,
                        type,
                        required,
                        onRemoveFile,
                        ...othersInputProps
                    } = input;
                    const { value } = inputValue;
                    return (
                        <Input
                            key={fieldId}
                            theme={theme}
                            onChange={this.onInputChange}
                            fieldId={fieldId}
                            value={value}
                            label={label}
                            placeholder={placeholder}
                            type={type}
                            required={required}
                            onRemoveFile={onRemoveFile}
                            {...othersInputProps}
                        />
                    );
                })}
            </div>
        );
    }
}

export default InputList;
